<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-40">
      <departure-summary
        :departure="departure"
        :tour="this.$route.params.tour_id"
        @departureUpdated="departureUpdated"
      />
    </div>
    <div class="md-layout-item md-size-60">
      <departure-tabs :departure="departure" />
    </div>
  </div>
</template>
<script>
import tourApi from "@/services/api/tour";

import DepartureSummary from "./DepartureSummary.vue";
import DepartureTabs from "./DepartureTabs.vue";

export default {
  components: {
    DepartureSummary,
    DepartureTabs
  },

  data() {
    return {
      departure: {
        prices: {}
      }
    };
  },

  methods: {
    getDeparture(tour_id, departure_id) {
      tourApi.getDeparture(tour_id, departure_id).then(response => {
        this.departure = response.data;
      });
    },

    departureUpdated(departure) {
      this.departure = departure;
      this.$emit("departureUpdated", departure);
    }
  },

  mounted() {
    this.getDeparture(
      this.$route.params.tour_id,
      this.$route.params.departure_id
    );
  }
};
</script>
